// extracted by mini-css-extract-plugin
export default {"test_card":"PartWorkReport_test_card__o+IpI","btn_print":"PartWorkReport_btn_print__hrbiN","div_print":"PartWorkReport_div_print__4ElcU"};